export default function Contact() {
  return (
    <>
      <h2>Contact</h2>
      <aside>
        <a href="mailto:damian@makki.pro">damian@makki.pro</a>
      </aside>
    </>
  )
}